import React, { Component } from 'react';
import { withRouter } from 'react-router';

class PedidoSearch extends Component {

  componentDidMount() {
    this.props.history.push('/home/pedido/search');
  }

  render() {
    return null;
  }
}

export default withRouter(PedidoSearch);